import React, { useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { Container, Button } from 'react-bootstrap';
import Loading from '../../Components/Loading';
import { FaSearch } from 'react-icons/fa';
import { useEffect } from 'react';
import ModalCancelar from '../../Components/DocumentoDigital/ModalCancelar';
import AuthStorage from '~/Utils/AuthStorage';
import * as constants from '~/constant';

const cancelarDocDgital = ({ codigoDocDigitalForceInput = 0 }) => {
  const [
    solicitacoesCancelamentoDocDigital,
    setSolicitacoesCancelamentoDocDigital,
  ] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [docsFitro, setDocsFiltro] = useState();
  const [filtroProposta, setFiltroProposta] = useState();
  const [showModalReprovacao, setShowModalReprovacao] = useState(false);
  const [motivos, setMotivos] = useState();
  const [docDigitalSelecionado, setDocDigitalSelecionado] = useState();
  const [logPreselecao, setLogPreselecao] = useState();
  useEffect(() => {
    getDocs();
  }, []);

  const podeSolicitarCancelamentoDocDigital = AuthStorage.temCaracteristica(
    constants.caracteristicas.DocDigitalSolicitarCanc
  );

  const getDocs = async () => {
    try {
      const codigo = Number(codigoDocDigitalForceInput) || 0;
      setIsLoading(true);
      const retorno = await api.BuscarSolicitacoesCancelamento(codigo);
      setDocsFiltro(retorno);
      setSolicitacoesCancelamentoDocDigital(retorno);
    } catch ({ Message }) {
    } finally {
      setIsLoading(false);
    }
  };

  const gravarCancelamento = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await api.cancelarDocumentoDigital(
        docDigitalSelecionado.codigo_doc_digital,
        values.observacao,
        values.motivoCancelar,
        false,
        true
      );

      toast.success('Documento cancelado com sucesso.');
    } catch (err) {
      toast.error(err.message || 'Falha ao cancelar o documento');
    } finally {
      setShowModalReprovacao(false);
      setLogPreselecao(null);
      getDocs();
    }
  };

  useEffect(() => {
    if (solicitacoesCancelamentoDocDigital) {
      const listaFiltrada = solicitacoesCancelamentoDocDigital.filter(item =>
        item.codigo_proposta.toString().includes(filtroProposta)
      );
      setDocsFiltro(listaFiltrada);
    }
  }, [filtroProposta]);

  async function fetchMotivos(tipoContrato) {
    setIsLoading(true);
    try {
      const response = await api.buscarMotivosCancelamento(tipoContrato);
      setMotivos(response);
    } catch (error) {
      console.error(error);
      toast.error(error.message || 'Falha ao buscar os motivos');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (docDigitalSelecionado) {
      setShowModalReprovacao(true);
      setLogPreselecao({
        codigo_motivo: docDigitalSelecionado.codigo_motivo_cancelamento_log,
        observacao: docDigitalSelecionado.observacao_log,
      });
      fetchMotivos(docDigitalSelecionado.tipo);
    }
  }, [docDigitalSelecionado]);

  const getBackGroundColor = () => {
    return !codigoDocDigitalForceInput ? '' : ' bg-light';
  };
  return (
    <div>
      {!podeSolicitarCancelamentoDocDigital && (
        <div className="text-center">
          <label>Usuário sem permissão para acessar a tela.</label>
        </div>
      )}

      {podeSolicitarCancelamentoDocDigital && (
        <div>
          {!codigoDocDigitalForceInput && (
            <Container>
              <h5 className="my-3">
                Solicitação De Cancelamento De Documento Digital
              </h5>
            </Container>
          )}

          {isLoading && (
            <Loading label="Buscando Solicitações De Cancelamento De Doc. Digital...." />
          )}
          {!isLoading &&
            solicitacoesCancelamentoDocDigital &&
            solicitacoesCancelamentoDocDigital.length === 0 &&
            !codigoDocDigitalForceInput && (
              <div className="text-center mt-3">
                Nenhuma Solicitação encontrada
              </div>
            )}
          {solicitacoesCancelamentoDocDigital &&
            solicitacoesCancelamentoDocDigital.length > 0 && (
              <Container>
                {!codigoDocDigitalForceInput && (
                  <div className="row mt-1">
                    <div className="col-12">
                      <div className="input-group input-focus">
                        <input
                          type="search"
                          placeholder="Buscar Proposta..."
                          className="form-control border-right-0"
                          onChange={e => setFiltroProposta(e.target.value)}
                        />
                        <div className="input-group-prepend">
                          <span className="input-group-text bg-white border-left-0">
                            <FaSearch />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="text-muted ml-3 mt-1">
                      {docsFitro && docsFitro.length > 0
                        ? `Exibindo ${docsFitro.length} solicitações de Cancelamento Doc. Digital.`
                        : `Nenhuma solicitação encontrada`}
                    </div>
                  </div>
                )}

                <div className="row mt-2">
                  {docsFitro &&
                    docsFitro.map((item, index) => (
                      <div className="col-12" key={index}>
                        <div
                          className={`mb-2 border-0 arrow-bottom-left proposta-${
                            item.codigo_proposta
                          } card ${getBackGroundColor()}`}
                        >
                          <div className="mx-3 my-1">
                            <ul className="list-unstyled d-flex mb-1">
                              <li>
                                <small className="d-block text-muted">
                                  Proposta
                                </small>
                                <strong>{item.codigo_proposta}</strong>
                              </li>
                              <li className="mr-2 ml-auto">
                                <small className="d-block text-muted">
                                  Corretor
                                </small>
                                <span>{item.corretor}</span>
                              </li>
                              <li>
                                <small className="d-block text-muted">
                                  Imobiliária
                                </small>
                                <span className="bullet"></span>
                                &nbsp;
                                {item.imobiliaria}
                              </li>
                            </ul>
                            <ul className="list-unstyled d-flex mb-1">
                              <li className="mr-2">
                                <small className="d-block text-muted">
                                  Empreendimento
                                </small>
                                <strong>{item.empreendimento}</strong>
                              </li>
                              <li className="mr-2 ml-auto">
                                <small className="d-block text-muted">
                                  Quadra
                                </small>
                                <strong>{item.quadra}</strong>
                              </li>
                              <li>
                                <small className="d-block text-muted">
                                  Lote
                                </small>
                                <strong>{item.lote}</strong>
                              </li>
                            </ul>
                            <ul className="list-unstyled d-flex mb-0">
                              <li className="mr-2">
                                <small className="d-block text-muted">
                                  Cliente
                                </small>
                                <span>{item.cliente}</span>
                              </li>
                              <li className="mr-2 ml-auto">
                                <div className="row mb-3 btn-center">
                                  <Button
                                    variant="danger"
                                    onClick={() =>
                                      setDocDigitalSelecionado(item)
                                    }
                                  >
                                    Cancelar
                                  </Button>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </Container>
            )}

          <ModalCancelar
            show={showModalReprovacao}
            onClosing={() => {
              setShowModalReprovacao(false);
            }}
            onSubmit={gravarCancelamento}
            opcao={'Cancelar'}
            isLoadingData={isLoading}
            motivos={motivos}
            pre_selecao={logPreselecao}
          />
        </div>
      )}
    </div>
  );
};

export default cancelarDocDgital;
